// The one canonical public origin. Every indexable URL the app emits
// (canonical link, og:url, server-injected meta) agrees on this exact host
// regardless of which host the page was loaded from — so a page never
// claims two different canonical URLs. www is the only fully-working host
// (Cloudflare -> app); the apex 301s to www for "/" only.
export const SITE_ORIGIN = "https://www.smallpotatoes.uk";

// Build an absolute canonical URL from an app-relative path.
export const absoluteUrl = (path) => {
  if (!path) return SITE_ORIGIN;
  return `${SITE_ORIGIN}${path.startsWith("/") ? path : `/${path}`}`;
};
